// Mock data for 3M Solar landing page

export const companyInfo = {
  name: "3M Solar",
  legalName: "Três Marias Solar",
  alternateName: "3MSolar",
  tagline: "Transforme sua despesa em investimento",
  description: "Reduza seus custos com energia solar em Patos de Minas, Três Marias e região. Projetos sob medida para empresas, propriedades rurais, comércios e residências, com instalação segura e atendimento especializado.",
  cnpj: "24.899.169/0001-93",
  stats: {
    installed: "3+ MW",
    clients: "100+",
    experience: "12 Anos"
  },
  contact: {
    phone: "(38) 99752-3325",
    phoneUrl: "https://wa.me/5538997523325",
    email: "arthur@3msolar.com.br",
    address: "Rua Barão do Rio Branco, 64, Patos de Minas - MG, 38700-170",
    mapsUrl: "https://maps.app.goo.gl/YgwxceX57JZyGWMy7"
  },
  social: {
    facebook: "https://www.facebook.com/tresmariassolar",
    instagram: "https://www.instagram.com/tresmariassolar",

  }
};

export const benefits = [
  {
    id: 1,
    title: "Economia de até 90%",
    description: "Livre-se dos aumentos na tarifa de energia e reduza sua conta de forma imediata.",
    icon: "Wallet"
  },
  {
    id: 2,
    title: "Valorização do Imóvel",
    description: "Sua propriedade passa a valer mais no mercado com um sistema de geração próprio.",
    icon: "TrendingUp"
  },
  {
    id: 3,
    title: "Retorno Rápido",
    description: "Investimento que se paga entre 2 a 3 anos, garantindo lucros pelas próximas décadas.",
    icon: "DollarSign"
  },
  {
    id: 4,
    title: "Sustentabilidade",
    description: "Produza energia 100% limpa, preservando o meio ambiente e sua pegada de carbono.",
    icon: "Leaf"
  },
  {
    id: 5,
    title: "Baixa Manutenção",
    description: "Os módulos solares exigem cuidados mínimos e possuem vida útil superior a 25 anos.",
    icon: "Settings"
  },
  {
    id: 6,
    title: "Independência Energética",
    description: "Pare de ser refém das bandeiras tarifárias e gere sua própria eletricidade.",
    icon: "Zap"
  }
];

export const howItWorks = [
  {
    id: 1,
    step: "01",
    title: "Análise Gratuita",
    description: "Avaliamos sua conta de luz e o seu imóvel para entender exatamente o seu potencial de economia."
  },
  {
    id: 2,
    step: "02",
    title: "Projeto Sob Medida",
    description: "Nossa equipe de engenharia cria a solução perfeita para atender sua necessidade de consumo sem desperdícios."
  },
  {
    id: 3,
    step: "03",
    title: "Instalação Descomplicada",
    description: "Equipe técnica executa a instalação de forma ágil, segura e sem sujeira."
  },
  {
    id: 4,
    step: "04",
    title: "Economia Imediata",
    description: "Pronto! O sistema é homologado, ativado e você começa a economizar logo no primeiro mês."
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Carlos Mendes",
    role: "Proprietário Residencial",
    text: "Estava cansado de pagar R$ 800 de luz todo mês. Com o sistema da 3M Solar, minha conta caiu para R$ 50. Instalação super rápida e equipe pontual!",
    rating: 5
  },
  {
    id: 2,
    name: "Ana Paula Silva",
    role: "Proprietária Rural",
    text: "Na nossa propriedade, os custos com energia eram um peso gigante. O investimento se pagou antes do previsto e o sistema funciona perfeitamente.",
    rating: 5
  },
  {
    id: 3,
    name: "Roberto Oliveira",
    role: "Dono de Comércio",
    text: "Melhor decisão financeira da empresa. Atendimento comercial muito transparente, tiraram todas as dúvidas pelo WhatsApp.",
    rating: 5
  }
];

export const faqData = [
  {
    id: 1,
    question: "A redução na conta de luz é mesmo de 90%?",
    answer: "Sim! Com o sistema ideal para o seu perfil de consumo, você paga somente a taxa mínima da concessionária e uma taxa sobre a geração excedente."
  },
  {
    id: 2,
    question: "O processo de instalação faz muita bagunça?",
    answer: "Não. Nossa equipe é especializada e realiza todo o trabalho de maneira rápida e segura, geralmente encerrando em poucos dias sem atrapalhar sua rotina."
  },
  {
    id: 3,
    question: "É possível financiar o sistema?",
    answer: "Com certeza! Em muitos casos, a economia mensal que você tem na conta de luz já paga a parcela do financiamento. O sistema 'se paga' sem você sentir no bolso."
  },
  {
    id: 4,
    question: "Vale a pena para residências, comércio ou área rural?",
    answer: "Sim. Nossos projetos são modulares: desde a casa para poupar da inflação energética, passando pelo comércio em busca de lucros maiores, até o produtor rural."
  },
  {
    id: 5,
    question: "Quanto tempo dura um sistema de energia solar?",
    answer: "Os painéis solares têm vida útil estimada de mais de 25 anos operando em alta performance e baixa necessidade de manutenção (apenas lavagem simples)."
  },
  {
    id: 6,
    question: "Se faltar energia da rua, o meu sistema continua gerando?",
    answer: "Os sistemas conectados à rede (On-Grid) são desligados automaticamente por segurança quando falta energia da concessionária. Mas com sistemas híbridos, é possível usar baterias para manter a energia ativa."
  }
];

export const projects = [
  {
    id: 1,
    title: "Casa em Belo Horizonte",
    category: "Residencial",
    power: "8 kWp",
    image: "https://images.unsplash.com/photo-1509391366360-2e959784a276",
    description: "Conta reduzida de R$ 900 para o custo mínimo. Instalação em 2 dias."
  },
  {
    id: 2,
    title: "Indústria Leve em Contagem",
    category: "Industrial",
    power: "150 kWp",
    image: "https://images.unsplash.com/photo-1613665813446-82a78c468a1d",
    description: "Projeto robusto garantindo fôlego financeiro em tempos de crise."
  },
  {
    id: 3,
    title: "Comércio Local",
    category: "Comercial",
    power: "45 kWp",
    image: "https://images.pexels.com/photos/6158914/pexels-photo-6158914.jpeg",
    description: "Geladeiras e refrigeração rodando muito mais barato o mês inteiro."
  },
  {
    id: 4,
    title: "Condomínio Residencial",
    category: "Residencial",
    power: "120 kWp",
    image: "https://images.pexels.com/photos/4254164/pexels-photo-4254164.jpeg",
    description: "Rateio inteligente diminuindo a taxa de condomínio para todos."
  },
  {
    id: 5,
    title: "Fazenda Produtiva",
    category: "Rural",
    power: "200 kWp",
    image: "https://images.unsplash.com/photo-1635424709961-f3a150459ad4",
    description: "Redução do custo com irrigação e equipamentos pesados usando o sol."
  },
  {
    id: 6,
    title: "Escritório Comercial",
    category: "Comercial",
    power: "25 kWp",
    image: "https://images.unsplash.com/photo-1613665813446-82a78c468a1d",
    description: "Ambiente climatizado sem medo das faturas no final do mês."
  }
];

export const mockFormSubmit = (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Form submitted (MOCK):", formData);
      resolve({ success: true, message: "Mensagem enviada com sucesso!" });
    }, 1000);
  });
};
